import React from 'react'
import PropTypes from 'prop-types'
import { Overlay } from 'react-bootstrap'
import PopContent from './PopContent'
import isEmpty from 'lodash/isEmpty'

class SimplePopover extends React.Component {
  render() {
    if (isEmpty(this.props.target)) return null
    return (
      <Overlay {...this.props} placement='top'>
        <PopContent content={this.props.content} />
      </Overlay>
    )
  }
}

SimplePopover.propTypes = {
  show: PropTypes.bool,
  container: PropTypes.object,
  target: PropTypes.object,
  content: PropTypes.string
}

SimplePopover.defaultProps = {
  show: false,
  content: 'Hey! What to show?'
}

export default SimplePopover



// WEBPACK FOOTER //
// ./src/components/widgets/SimplePopover.js